import PropTypes from 'prop-types';
import o from "ramda/es/o";
import prop from "ramda/es/prop";
import propOr from "ramda/es/propOr";
import cx from "ramda-extension/es/cx";
import isArray from "ramda-extension/es/isArray";
import React, { cloneElement, useCallback } from 'react';
import HorizontalScroll from '../../HorizontalScroll';
import Menu from '../../Menu/Menu';
import TabMenuItem from '../TabMenuItem';
const propsP = prop('props');
const labelPath = o(prop('label'), propsP);
const disabledPath = o(prop('disabled'), propsP);
const hideablePath = o(prop('hideable'), propsP);
const visiblePath = o(propOr(true, 'visible'), propsP);
const listItemPath = o(prop('listItemElement'), propsP);
const TabsHorizontalMenu = ({ renderPanel, activeTab, handleTabLinkClick, useHorizontalScroll, opened, children })=>{
    const renderTabLink = useCallback((child, index)=>{
        const visible = visiblePath(child);
        if (!visible) {
            return null;
        }
        const active = activeTab === index;
        const listItemElement = listItemPath(child);
        const itemProps = {
            key: index,
            index,
            label: labelPath(child),
            onClick: handleTabLinkClick,
            active,
            opened: opened && active,
            disabled: disabledPath(child),
            hideable: hideablePath(child)
        };
        return listItemElement ? /*#__PURE__*/ cloneElement(listItemElement, itemProps) : /*#__PURE__*/ React.createElement(TabMenuItem, itemProps);
    }, [
        activeTab,
        opened,
        handleTabLinkClick
    ]);
    const child = !isArray(children) ? [
        children
    ] : children;
    return useHorizontalScroll ? /*#__PURE__*/ React.createElement(HorizontalScroll, {
        className: cx({
            'Menu--typeTabs2': !renderPanel,
            'Menu--typeTabs': renderPanel
        }),
        activeIndex: activeTab
    }, child?.map?.(renderTabLink)) : /*#__PURE__*/ React.createElement(Menu, {
        horizontal: true,
        className: cx({
            'Menu--typeTabs2': !renderPanel,
            'Menu--typeTabs': renderPanel
        })
    }, child?.map?.(renderTabLink));
};
TabsHorizontalMenu.propTypes = {
    activeTab: PropTypes.any,
    children: PropTypes.any,
    handleTabLinkClick: PropTypes.func,
    opened: PropTypes.bool,
    renderPanel: PropTypes.bool,
    useHorizontalScroll: PropTypes.bool
};
export default TabsHorizontalMenu;
